// extracted by mini-css-extract-plugin
export default {"wrapper":"Blocks_wrapper__WROiu","inner":"Blocks_inner__twTTc","wrapSkeleton":"Blocks_wrapSkeleton__StFaB","image":"Blocks_image__QICdm","skeleton":"Blocks_skeleton__HIjMA"};